import SalesWelcomeCard from "./SalesWelcomeCard";
export default SalesWelcomeCard;
